/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TextCustomField } from './TextCustomField';
import {
    TextCustomFieldFromJSON,
    TextCustomFieldFromJSONTyped,
    TextCustomFieldToJSON,
} from './TextCustomField';

/**
 * 
 * @export
 * @interface AccountCustomFields
 */
export interface AccountCustomFields {
    /**
     * A list of text-based custom fields associated with the sign request
     * @type {Array<TextCustomField>}
     * @memberof AccountCustomFields
     */
    textCustomFields?: Array<TextCustomField>;
}

/**
 * Check if a given object implements the AccountCustomFields interface.
 */
export function instanceOfAccountCustomFields(value: object): boolean {
    return true;
}

export function AccountCustomFieldsFromJSON(json: any): AccountCustomFields {
    return AccountCustomFieldsFromJSONTyped(json, false);
}

export function AccountCustomFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountCustomFields {
    if (json == null) {
        return json;
    }
    return {
        
        'textCustomFields': json['textCustomFields'] == null ? undefined : ((json['textCustomFields'] as Array<any>).map(TextCustomFieldFromJSON)),
    };
}

export function AccountCustomFieldsToJSON(value?: AccountCustomFields | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'textCustomFields': value['textCustomFields'] == null ? undefined : ((value['textCustomFields'] as Array<any>).map(TextCustomFieldToJSON)),
    };
}

